module.exports = __webpack_public_path__ + "img/2010.25fb7928.png";